import emailjs from "emailjs-com";
import { useEffect, useState } from "react";

const Contact = () => {
   const [mailData, setMailData] = useState({
      name: "",
      email: "",
      asunto: "",
      message: "",
   });
   const { name, email, message, asunto } = mailData;
   const [error, setError] = useState();

   const handleChange = (e) =>
      setMailData({ ...mailData, [e.target.name]: e.target.value });

   const handleSubmit = (e) => {
      e.preventDefault();
      if (
         name.length === 0 ||
         email.length === 0 ||
         message.length === 0 ||
         asunto.length === 0
      ) {
         setError(true);
         clearError();
      } else {
         emailjs.send(
            "service_gohbaji", // service id
            "template_csepcqf", // template id
            mailData,
            "PV17sLPwBTOQeDO_H" // public api
         )
            .then(
               (response) => {
                  setError(false);
                  clearError();
                  setMailData({ name: "", email: "", message: "", asunto: "" });
               },
               (err) => {
                  console.log(err.text);
               }
            );
      }
   };
   const clearError = () => {
      document.getElementById("contact-form").reset();
      setTimeout(() => {
         setError(null);
      }, 3000);
   };

   useEffect(() => {
   }, [error]);

   return (


      <section id="contactus" data-nav-tooltip="Contact Me" className="pp-section pp-scrollable section dark-bg">
         <div className="separated" />
         <div className="container">
            <div className="title">
               <h3>Ponte en contacto.</h3>
            </div>
            <div className="row">
               <div className="col-lg-5 col-xl-4 m-15px-tb">
                  <div id="contact-info" className="contact-info">
                     <h4>Cuál es tu historia? Escríbeme.</h4>
                     <p>Siempre disponible para trabajar como autónomo si surge el proyecto adecuado. No dudes en ponerte en contacto conmigo.</p>
                     <ul>
                        <li className="media"><i className="ti-map"></i><span className="media-body">Concepción, Chile.</span></li>
                        <li className="media"><i className="ti-email"></i><span className="media-body">islaszuniga@gmail.com</span></li>
                        <li className="media"><i className="ti-mobile"></i><span className="media-body">+56 9 48044323</span></li>
                     </ul>
                  </div>
               </div>
               <div className="col-lg-7 col-xl-8 m-15px-tb">
                  <div className="contact-form">
                     <h4>Di algo!</h4>
                     <form id="contact-form" onSubmit={handleSubmit}>
                        <div className="row">
                           <div className="col-md-6">
                              <div className="form-group"><input name="name" id="name" placeholder="Nombre *" className="form-control " type="text" defaultValue="" onChange={(e) => handleChange(e)} /></div>
                           </div>
                           <div className="col-md-6">
                              <div className="form-group"><input name="email" id="email" placeholder="Email *" className="form-control " type="email" defaultValue="" onChange={(e) => handleChange(e)} /></div>
                           </div>
                           <div className="col-12">
                              <div className="form-group"><input name="asunto" id="asunto" placeholder="Asunto *" className="form-control " type="text" defaultValue="" onChange={(e) => handleChange(e)} /></div>
                           </div>
                           <div className="col-md-12">
                              <div className="form-group"><textarea name="message" id="message" placeholder="Tu mensaje *" rows="5" className="form-control " onChange={(e) => handleChange(e)}></textarea></div>
                           </div>
                           <div className="col-md-12">
                              <div className="send"><input className="px-btn px-btn-theme" type="submit" defaultValue="send message" /></div>
                              {
                                 error === false ?
                                    <div className="alert alert-primary mt-3" role="alert">
                                       <i className="far fa-check-circle" style={{ fontSize: '20px' }}></i>
                                       <span>{' '}Mensaje enviado exitosamente!</span>
                                    </div> : error === true ?
                                       <div className="alert alert-danger mt-3">
                                          <i className="far fa-times-circle" style={{ fontSize: '20px' }}></i>
                                          <span>{' '}Error al enviar el mensaje, intente nuevamente.
                                          </span>
                                       </div> : <></>
                              }
                           </div>
                        </div>
                     </form>
                  </div>
               </div>
            </div>
         </div>
         <br></br>
         <br></br>
      </section>
   );
};
export default Contact;
